import {
  Avatar,
  Divider,
  IconButton,
  Menu,
  MenuItem,
  Tooltip,
  Typography,
  useTheme,
} from '@mui/material';
import { FC, MouseEvent, useState } from 'react';
import ThemeSwitch from './ThemeSwitch/ThemeSwitch';
import LanguageSwitch from './LanguageSwitch/LanguageSwitch';
import styled from 'styled-components';
import MenuHeading from '../../Typography/MenuHeading/MenuHeading';
import { User } from '../../../shared/interfaces/IUser';

interface Props {
  user: User | null;
  logout: () => void;
}

const MenuUsernameContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const AvatarMenuContainer = styled.div`
  display: flex;
  align-items: center;
  padding: ${(props) => props.theme.spacing(2)};
  margin: 0;
`;

const AvatarMenu: FC<Props> = ({ user, logout }) => {
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Tooltip title="Account">
        <IconButton
          onClick={handleClick}
          size="small"
          sx={{ ml: 2 }}
          aria-controls={open ? 'account-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
        >
          <Avatar
            alt={`${user?.firstName} ${user?.lastName}`}
            src="#"
            sx={{ width: 32, height: 32, fontSize: '0.85rem' }}
          >
            {user?.firstName?.charAt(0)}
            {user?.lastName?.charAt(0)}
          </Avatar>
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            minWidth: 300,
            overflow: 'visible',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            mt: 1.5,
            '&:before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: 'background.paper',
              transform: 'translateY(-50%) rotate(45deg)',
              zIndex: 0,
            },
            '& .MuiButtonBase-root + .MuiDivider-root': {
              margin: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <AvatarMenuContainer>
          <Avatar
            alt={`${user?.firstName} ${user?.lastName}`}
            src="#"
            sx={{ width: 56, height: 56, mr: theme.spacing(1) }}
          >
            {user?.firstName?.charAt(0)}
            {user?.lastName?.charAt(0)}
          </Avatar>
          <MenuUsernameContainer>
            <Typography variant="body1">
              {user?.firstName} {user?.lastName}
            </Typography>
            <Typography variant="caption">{user?.email}</Typography>
          </MenuUsernameContainer>
        </AvatarMenuContainer>
        <Divider />
        <MenuHeading text="Menu" />
        <MenuItem sx={{ display: 'none', py: theme.spacing(2) }}>Account</MenuItem>
        <MenuItem sx={{ display: 'none', py: theme.spacing(2) }}>Settings</MenuItem>
        <MenuItem
          sx={{ py: theme.spacing(2) }}
          onClick={() => logout()}
        >
          Logout
        </MenuItem>
        <Divider />
        <ThemeSwitch />
        <Divider />
        <LanguageSwitch />
      </Menu>
    </>
  );
};

export default AvatarMenu;
